export function isValidNumber(value?: number | string | null) {
  return value !== null && !isNaN(Number(value));
}

export function roundFloat(value: number, precision: number): number {
  const roundedValue = isValidNumber(precision) && !Number.isInteger(value) ? Number(value.toFixed(precision)) : value;

  return roundedValue;
}

export function roundNumberToPrecision(val: number, precision: number) {
  validateIsDefinedNumber(val, 'val');
  validateIsDefinedNumber(precision, 'precision');

  return Number(val.toFixed(precision));
}

function validateIsDefinedNumber(val: number, variableName: string) {
  if (!isValidNumber(val)) {
    throw new Error(`${variableName} must be a defined number`);
  }
}
